import React, { useMemo } from "react";
import { MetricCompareSelectField, ConditionValues, ConditionScope } from "components/custom/programs/fields";
import { Form } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import makeConditionOptions from "./makeConditionOptions";
import { useProgramContext } from "./ProgramContext";
import { useModuleEnabled } from "redux/selectors/modules";
import { useAppSelector } from "redux/hooks";
import { getCurrencySymbol } from "utils/formatNumber";

/*
Conditions

Every-time i sell N units
Every N days
After Jan 1st 2021
Before Jan 1st
Between Jan 1st and Jan 31st
When N total units is sold
When N day average units sold is less than M
When N day average units sold is more than M

*/

const ConditionForm = ({ fieldName, control, scope, divider, engine = null }) => {
  const ctx = useProgramContext();
  engine = engine || ctx.engine;
  const hasTacosRules = useModuleEnabled("TACOS_RULES");
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const selectedCondition = useWatch({
    name: `${fieldName}.option`,
    control,
  });
  const conditionOptions = useMemo(() => {
    const options = makeConditionOptions(scope, engine);
    if (engine === "bidding" && !hasTacosRules) {
      return options.filter((o) => !["tacos", "troas", "total_cr"].includes(o.group));
    }

    return options;
  }, [scope, engine, hasTacosRules]);

  const [, accessor] = selectedCondition ? JSON.parse(selectedCondition) : [null, null];

  let { scopeText, showScope, symbol } = conditionOptions?.find((o) => o.value === accessor) ?? {};

  if (symbol === "currency") {
    symbol = getCurrencySymbol(marketPlace);
  }
  if (symbol === "percent") {
    symbol = "%";
  }

  return (
    <Form.Group>
      <div className={`d-flex align-items-center fs-standard flex-wrap ${divider ? "border-top pt-3" : ""}`}>
        {/* Metric select starts */}
        <MetricCompareSelectField
          fieldName={`${fieldName}.option`}
          control={control}
          rules={{ required: true }}
          metricOptions={conditionOptions}
        />
        <ConditionValues
          control={control}
          fieldName={fieldName}
          selectedOption={selectedCondition}
          conditionOptions={conditionOptions}
          scopeText={scopeText}
          accessor={accessor}
          symbol={symbol}
        />
        {showScope && (
          <ConditionScope
            control={control}
            fieldName={fieldName}
            selectedOption={selectedCondition}
            conditionOptions={conditionOptions}
          />
        )}
      </div>
    </Form.Group>
  );
};

export default ConditionForm;
